import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    userDetails: { name: "", userName: "", permissionRoles: [], sgNames: [] },
    isLoading: true,
    error: "",
  },

  reducers: {
    fetchDataRequest: (state, action) => {
      state.isLoading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.userDetails = action.payload.userDetails;
      state.isLoading = false;
    },
    fetchDataFailure: (state, action) => {
      const { error } = action.payload;
      state.isLoading = false;
      state.error = error;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
